// ナチュラル・カスタムテーマ JS
document.addEventListener('DOMContentLoaded', () => {
  console.log('ナチュラル・カスタムテーマが読み込まれました。');
  
  // モバイルメニュー等の制御（将来的な拡張枠）
  const initMobileMenu = () => {
    // 簡易的な処理
  };
  
  initMobileMenu();
});
